import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { getCollectionBySlug } from '../../common/Rest/Services/BookService';
import { BookCollection } from '../../common/Models/Books';
import { getBookImageUrl } from '../../common/Utils/BookImages';
import ROUTES from '../../common/Routing/Routes';
import './ListPage.css';

function ListPage() {
  const { slug } = useParams<{ slug: string }>();
  const [collection, setCollection] = useState<BookCollection | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) return;

    setLoading(true);
    setNotFound(false);
    getCollectionBySlug(slug)
      .then(setCollection)
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="list-page default-container">
        <CircularProgress sx={{ display: 'block', margin: '60px auto' }} />
      </div>
    );
  }

  if (notFound || !collection) {
    return (
      <div className="list-page default-container">
        <p className="list-empty">Цю підбірку не знайдено — можливо, посилання застаріле.</p>
      </div>
    );
  }

  const items = [...collection.items].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <div className="list-page default-container">
      <header className="list-header">
        <h1>{collection.title}</h1>
        {collection.description && <p>{collection.description}</p>}
      </header>

      <ul className="list-items">
        {items.map(({ book, comment }) => (
          <li className="list-item-card" key={book.id}>
            <Link to={`${ROUTES.DETAILS}/${book.id}`} className="list-item-cover-link">
              <img src={getBookImageUrl({ id: book.id, isbn: book.isbn, image: undefined, primaryImage: book.primaryImage, images: book.images })} alt={book.name} className="list-item-cover" />
            </Link>
            <div className="list-item-body">
              <Link to={`${ROUTES.DETAILS}/${book.id}`} className="list-item-title">
                {book.name}
              </Link>
              <p className="list-item-authors">
                {book.authors.map((author) => author.name).join(', ') || 'Автор не вказаний'}
              </p>
              {comment && <p className="list-item-comment">{comment}</p>}
              <Link to={`${ROUTES.DETAILS}/${book.id}`} className="list-item-cta">
                Дивитись книгу
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ListPage;
